<template>
  <div>
    <!-- 头 -->
    <Header
      ref="header"
      style="z-index: 9999"
      :title="title"
      :showBack="!isFromDriver"
      :isFromDriver="isFromDriver"
    >
    </Header>

    <!-- 主体 -->
    <div class="security-content">
      <div class="security-content-card ">
        <van-form @submit="onSubmit">
          <SecurityPicker
            label="线路"
            name="line"
            :parentSelectorActive="lineValue"
            @comfirm="clickComfirm"
          ></SecurityPicker>

          <SecurityPicker
            ref="startNode"
            label="起点"
            name="startNode"
            :pickerParam="lineValue"
            @comfirm="clickComfirm"
          ></SecurityPicker>

          <SecurityPicker
            ref="endNode"
            label="终点"
            name="endNode"
            :pickerParam="lineValue"
            @comfirm="clickComfirm"
          ></SecurityPicker>

          <SecurityPicker
            label="车辆"
            name="car"
            @comfirm="clickComfirm"
          ></SecurityPicker>

          <van-cell
            title="出站日期"
            :value="queryData.OutDate"
            @click="isShowSecurityOutDate = true"
            :border="false"
            class="security-cell"
            is-link
          />

          <van-cell
            title="出站时间"
            :value="queryData.OutTime"
            @click="isShowSecurityOutTime = true"
            :border="false"
            class="security-cell"
            is-link
          />

          <SecurityCheckbox @changeCheckbox="changeCheckbox"></SecurityCheckbox>

          <van-field
            class="security-cell"
            v-model="queryData.OtherNotes"
            label="其他事项"
            placeholder="请输入其他事项"
            input-align="right"
            type="textarea"
            rows="1"
            autosize
          />
          <van-field
            class="security-cell"
            v-model="queryData.DriverSign"
            label="司机签名"
            placeholder="请输入司机签名"
            input-align="right"
          />
          <van-field
            class="security-cell"
            v-model="queryData.CheckSign"
            label="检查人签名"
            placeholder="请输入检查人签名"
            input-align="right"
          />
          <van-field
            class="security-cell"
            v-model="queryData.Notes"
            label="备注"
            placeholder="请输入备注"
            input-align="right"
            type="textarea"
            rows="1"
            autosize
          />

          <div style="margin-top: .3rem;">
            <van-button
              round
              block
              type="info"
              native-type="submit"
              readonly
              required
            >
              提交
            </van-button>
          </div>
        </van-form>
      </div>
    </div>

    <!-- 日期选择 -->
    <van-calendar
      v-model="isShowSecurityOutDate"
      @confirm="confirmSecurityOutSitesDate"
      :default-date="new Date()"
    />
    <!-- 时间选择 -->
    <van-popup
      v-model="isShowSecurityOutTime"
      position="bottom"
      @open="openSecurityOutSiteTimePopup"
    >
      <van-datetime-picker
        v-model="securityOutSiteTime"
        type="time"
        title="选择时间"
        @confirm="confirmSecurityOutSitesTime"
        @cancel="isShowSecurityOutTime = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import SecurityPicker from "./components/SecurityPicker.vue";
import SecurityCheckbox from "./components/SecurityCheckbox.vue";

export default {
  // 车辆搜索

  components: {
    Header,
    SecurityPicker,
    SecurityCheckbox,
  },
  data() {
    return {
      title: "安检单新增", //标题
      isFromDriver: false,

      lineValue: {}, // 线路
      securityOutSiteTime: "", // 出站时间
      isShowSecurityOutDate: false, // 出站日期
      isShowSecurityOutTime: false, // 出站时间

      queryData: {
        OutDate: "",
        CreateGID: "",
        CreateCode: "",
        CreateName: "黄喜",
        CreateTime: "2024-01-25T16:41:50",
        GID: "",
        ModifyTime: "2024-01-25T16:41:50",
        ModifyGID: "",
        ModifyCode: "",
        ModifyName: "黄喜",
        LineGID: "",
        StartNodeGID: "",
        ArrivalNodeGID: "",
        VehicleGID: "",
        OutTime: "",
        IsCertComplete: false,
        IsVehiclePrecedent: false,
        IsCustomerBaggageAnomaly: false,
        IsCustomerRealNameException: false,
        IsFastenSeatBelts: false,
        IsOverCustomer: false,
        OtherNotes: "",
        DriverSign: "",
        CheckSign: "",
        Notes: "",
      },
    };
  },
  mounted() {
    this.getCurrentDateTime();
    this.getLocalData();
  },
  methods: {
    // 获取本地数据
    getLocalData() {
      let localData = this.$utils.localData.get("adminInfo", Object);
      this.queryData.CreateGID = localData.GID;
      this.queryData.ModifyGID = localData.GID;
      this.queryData.CreateName = localData.UserName;
      this.queryData.ModifyName = localData.UserName;
      this.queryData.CreateCode = localData.UserCode;
      this.queryData.ModifyCode = localData.UserCode;
      this.queryData.GID = localData.OrganizationGID;
    },
    // 获取当前日期时间
    getCurrentDateTime() {
      let date = this.$moment(this.$moment());
      this.queryData.OutDate = date.format("YYYY-MM-DD");
      this.queryData.CreateTime = date.format("YYYY-MM-DD HH:mm:ss");
      this.queryData.ModifyTime = date.format("YYYY-MM-DD HH:mm:ss");
      this.queryData.OutTime = date.format("HH:mm");
    },
    // 复选框
    changeCheckbox(data) {
      this.queryData = Object.assign(this.queryData, data);
    },

    // 出站时间 弹出框 确定按钮
    confirmSecurityOutSitesTime(data) {
      this.queryData.OutTime = data;
      this.isShowSecurityOutTime = false;
    },
    openSecurityOutSiteTimePopup() {
      this.securityOutSiteTime = this.queryData.OutTime;
    },

    // 出站日期 弹出框 确定按钮
    confirmSecurityOutSitesDate(date) {
      this.queryData.OutDate = this.$moment(date).format("YYYY-MM-DD");
      this.isShowSecurityOutDate = false;
    },

    // 线路选择框返回
    clickComfirm(data, type) {
      if (type === "line") {
        this.lineValue = data;
        this.queryData.LineGID = data.LineGID;
        this.$nextTick(function() {
          this.$refs.startNode.handlerClearData();
          this.$refs.endNode.handlerClearData();
        });
      } else if (type === "startNode") {
        this.queryData.StartNodeGID = data.NodeGID;
      } else if (type === "endNode") {
        this.queryData.ArrivalNodeGID = data.NodeGID;
      } else if (type === "car") {
        this.queryData.VehicleGID = data.VehicleGID;
      }
    },

    // 点击提交
    onSubmit() {
      this.$http
        .post(this.$api.GuestNodeManageCheckCreate, {
          _JsonText: JSON.stringify(this.queryData),
        })
        .then((res) => {
          if (res.success) {
            this.$toast("添加成功");
            setTimeout(() => {
              this.$router.go(-1);
            }, 800);
          } else {
            this.$toast("添加失败 - " + res.msg);
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.security-content {
  padding: 0.3rem;

  .security-content-card {
    background-color: #fff;
    padding: 0 0.3rem 0.3rem;
    .security-cell {
      border-bottom: 1px solid #dddddd85;
      font-size: 0.42rem;
      /deep/ .van-cell__title {
        display: flex;
        justify-items: flex-start;
        color: #000;
      }
      .van-cell__value {
        color: #000;
      }
    }
    .van-cell::after {
      border: none;
    }
  }
}
</style>
